const DealerCardSkeleton = () => {
    return (
        <div className='mtt-dealer-card'>
            <div className='mtt-dealer-card-skeleton mtt-dealer-card-skeleton--long'/>
            <div className='mtt-dealer-card-skeleton mtt-dealer-card-skeleton--medium'/>
            <div className='mtt-dealer-card-skeleton mtt-dealer-card-skeleton--short'/>
        </div>
    )
}

export default DealerCardSkeleton
